import { useEffect, useRef } from "react"
import { useQuery } from "@tanstack/react-query"
import config from "config"
import { merge } from "lodash"
import markerIcon from "../assets/location-marker.svg"

const apikey = config("liveTrafficApiKey")
const HereMap = window.HereMap

const createPlatformDefaultLayers = (apikey) => {
  try {
    if (!apikey) {
      throw new Error("API key is missing or invalid")
    }
    const platform = new HereMap.service.Platform({ apikey })
    const defaultLayers = platform.createDefaultLayers()
    return defaultLayers
  } catch (err) {
    console.warn(err.message)
  }
}

const defaultLayers = createPlatformDefaultLayers(apikey)

const DEFAULT_OPTIONS = {
  staleTime: 1000 * 60 * 60,
  zoom: 15.125,
  pixelRatio: 1,
}

export const useLiveTrafficMap = (center, options) => {
  const map = useRef(null)
  const mapDivRef = useRef(null)

  const { marker, staleTime, ...resOptions } = merge(DEFAULT_OPTIONS, options)

  useQuery({
    queryKey: ["trafficLayer"],
    queryFn: () => {
      const provider = defaultLayers.vector.traffic.map.getProvider()
      provider.reload(true)
      return true
    },
    staleTime, // 1 hour stale time
    initialData: true,
  })

  useEffect(() => {
    if (!map.current && apikey) {
      const mapHere = new HereMap.Map(
        mapDivRef.current,
        defaultLayers.vector.normal.map,
        {
          center: center,
          ...resOptions,
        }
      )
      mapHere.addLayer(defaultLayers.vector.traffic.map)
      map.current = mapHere
    }
  }, [center, resOptions])

  useEffect(() => {
    if (marker && apikey) {
      const icon = new HereMap.map.Icon(markerIcon)
      const emqMarker = new HereMap.map.Marker(marker, { icon })
      map.current.addObject(emqMarker)
    }
  }, [marker])

  return { ref: mapDivRef }
}
